/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BenefitDocumentDto } from './BenefitDocumentDto';
import type { CreateApplicationErrorDto } from './CreateApplicationErrorDto';
import type { SubmittedApplicationPaymentDto } from './SubmittedApplicationPaymentDto';

export type CreateApplicationResultDto = {
  applicationId: string;
  status: CreateApplicationResultDto.status;
  errors: Array<CreateApplicationErrorDto>;
  submittedAt?: string;
  submissionEvidence?: BenefitDocumentDto;
  payment?: SubmittedApplicationPaymentDto;
};
export namespace CreateApplicationResultDto {
  export enum status {
    CREATED = 'CREATED',
    CREATED_WITH_ERRORS = 'CREATED_WITH_ERRORS',
  }
}
